import { apiFetch, API } from "../services/api";

// Export CSV des participants d'un évènement, triés par créneau (ordre
// chronologique) puis marque puis nom : groupes lisibles dans Excel.
// Séparateur « ; » + BOM UTF-8 pour que l'Excel français ouvre le fichier
// directement avec les accents.
const csvEscape = (v) => '"' + String(v == null ? "" : v).replace(/"/g, '""') + '"';
const compareFr = (a, b) => String(a || "").localeCompare(String(b || ""), "fr", {sensitivity: "base"});
// Paddock : Matin, Après-midi, Libre service ; VMA : Midi, Soir ; puis alphabétique
// pour l'heure précise ("Midi - 12h" avant "Midi - 12h30").
const slotOrder = ["Matin", "Après-midi", "Libre service", "Midi", "Soir"];
const slotRank = (slot) => { const i = slotOrder.findIndex(p => String(slot || "").startsWith(p)); return i === -1 ? slotOrder.length : i; };
const compareSlot = (a, b) => (slotRank(a) - slotRank(b)) || compareFr(a, b);

export function buildAttendeesCsv(attendees) {
    const rows = [...attendees].sort((a, b) =>
        compareSlot(a.sessionSlot, b.sessionSlot) ||
        compareFr(a.favoriteBrand, b.favoriteBrand) ||
        compareFr(a.frontUser && a.frontUser.name, b.frontUser && b.frontUser.name) ||
        compareFr(a.frontUser && a.frontUser.firstName, b.frontUser && b.frontUser.firstName));
    const header = ["Créneau", "Marque", "Nom", "Prénom", "Email", "Participation validée"];
    const lines = rows.map(a => [
        a.sessionSlot, a.favoriteBrand,
        a.frontUser && a.frontUser.name, a.frontUser && a.frontUser.firstName, a.frontUser && a.frontUser.email,
        a.isValidated ? "oui" : "non",
    ].map(csvEscape).join(";"));
    return "\uFEFF" + [header.map(csvEscape).join(";"), ...lines].join("\r\n");
}

export function downloadCsv(filename, content) {
    const blob = new Blob([content], {type: "text/csv;charset=utf-8"});
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

const slugify = (s) => String(s || "export").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9]+/g, "-").replace(/^-+|-+$/g, "").toLowerCase();

/**
 * Depuis la liste des évènements : charge toutes les participations, garde
 * celles de l'évènement et télécharge le CSV. Renvoie le nombre de lignes.
 */
export async function exportEventAttendees(event) {
    const response = await apiFetch(API.back + '/physical-event-attendees', {method: 'GET'});
    const all = await response.json();
    const attendees = (Array.isArray(all) ? all : []).filter(a => a.event && a.event.id === event.id);
    downloadCsv("participants-" + slugify(event.name) + "-" + String(event.date || "").slice(0, 10) + ".csv", buildAttendeesCsv(attendees));
    return attendees.length;
}
